var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 261.006C512 265.659 512 270.311 511.458 274.963C511.458 279.034 510.915 282.523 510.373 286.013C509.83 294.154 508.745 302.296 507.118 310.438C506.575 314.508 505.491 317.998 504.948 321.487C501.151 337.189 496.269 351.727 489.759 366.266C488.132 370.337 486.504 373.826 484.335 377.315C479.995 386.038 475.113 394.18 469.688 402.322C467.518 406.392 464.806 409.882 461.551 413.371C455.041 422.094 448.532 430.236 440.937 437.796C437.14 441.867 433.343 445.356 429.003 448.845C419.781 457.568 409.474 465.128 398.625 471.525C392.116 475.596 385.606 479.667 379.096 482.575C349.803 497.695 316.713 505.837 281.996 505.837H229.919V14.4314C229.919 14.4314 245.651 14.4314 281.996 14.4314C319.426 14.4314 355.228 24.3176 386.691 41.764C393.201 45.2532 399.168 48.7426 405.135 52.8134C415.984 59.7919 425.748 67.9335 434.97 77.2382C438.768 80.7275 442.565 84.7983 445.82 88.2875C457.754 101.082 468.061 115.62 477.282 130.74C479.452 134.23 481.622 138.3 483.25 141.79C490.844 156.328 496.811 171.448 501.151 187.732C502.236 191.221 503.321 195.292 503.863 198.781C506.575 210.993 508.745 223.206 509.83 235.418C510.373 238.908 510.373 242.978 510.915 246.468C512 252.283 512 256.354 512 261.006Z",
    fill: "#CC9007"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M511.458 274.382C511.458 278.452 510.916 281.942 510.373 285.431H446.362V274.382H511.458Z",
    fill: "#AA7A06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M507.117 310.438C506.575 314.509 505.49 317.998 504.948 321.488H426.29V310.438H507.117Z",
    fill: "#AA7A06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M489.759 366.266C488.132 370.336 486.504 373.826 484.335 377.315H406.762V366.266H489.759Z",
    fill: "#AA7A06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M469.688 402.321C467.518 406.392 464.806 409.881 461.551 413.371H381.267V402.321H469.688Z",
    fill: "#AA7A06"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M441.48 438.378C437.683 442.449 433.886 445.938 429.546 449.427H354.144V438.378H441.48Z",
    fill: "#AA7A06"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M399.71 472.107C393.201 476.177 386.691 480.248 380.181 483.156H315.628V472.107H399.71Z",
    fill: "#AA7A06"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M511.458 248.212H442.023V237.163H510.373C510.915 240.652 511.458 244.723 511.458 248.212Z",
    fill: "#AA7A06"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M504.947 199.944H434.427V188.895H501.692C502.777 192.384 503.862 196.455 504.947 199.944Z",
    fill: "#AA7A06"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M483.792 142.952H413.272V131.903H477.825C479.995 135.392 481.622 138.881 483.792 142.952Z",
    fill: "#AA7A06"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M446.362 88.8698H367.705V77.8204H435.513C439.31 81.3097 443.107 84.7989 446.362 88.8698Z",
    fill: "#AA7A06"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M405.677 53.395H329.733V42.3457H387.776C393.201 45.2534 399.71 49.3242 405.677 53.395Z",
    fill: "#AA7A06"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M459.924 261.007C459.924 396.507 357.398 507 230.462 507C103.525 507 0.999878 397.088 0.999878 261.007C0.999878 125.507 103.525 15.0134 230.462 15.0134C357.398 15.0134 459.924 124.925 459.924 261.007Z",
    fill: "#FFD000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M420.866 261.006C420.866 373.826 335.7 465.128 230.462 465.128C125.224 465.128 40.0573 373.826 40.0573 261.006C40.0573 148.187 125.224 56.8842 230.462 56.8842C335.7 56.8842 420.866 148.187 420.866 261.006Z",
    fill: "#FCBC00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M246.193 447.683C140.955 447.683 55.7888 356.38 55.7888 243.56C55.7888 191.803 74.2325 144.116 104.068 108.061C65.0107 145.279 40.0573 199.945 40.0573 260.425C40.0573 373.245 125.224 464.547 230.462 464.547C286.878 464.547 337.87 437.796 372.587 395.925C338.955 428.492 295.015 447.683 246.193 447.683Z",
    fill: "#C57F0C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.086 309.2V248.756C223.086 215.118 247.793 186.81 279.16 186.018C311.471 185.197 338 213.137 338 247.602V300.835C338 305.457 334.508 309.2 330.197 309.2H223.086V309.2Z",
    fill: "#CC9007"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.931 248.756V309.2H230.153C230.139 309.201 230.125 309.201 230.111 309.201H123V248.756C123 215.119 147.707 186.81 179.074 186.018C198.517 185.524 215.866 195.444 226.601 210.934C219.263 221.521 214.931 234.671 214.931 248.756Z",
    fill: "#CC9007"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuna);
export default __webpack_public_path__ + "static/media/MUNA.d78caec1311ab7784c85687db44a1e3e.svg";
export { ForwardRef as ReactComponent };